<template>
    <header class="header">
        <div class="header-info">
          <h1>Campaign Manager</h1>
          <p>for OBS AdCaster</p>
        </div>
        <div class="user-profile" @click="toggleMenu">
          <div class="avatar">MP</div>
          <div v-if="menuOpen" class="context-menu">
            <div class="menu-header">
              <strong>{{ userFullName }}</strong>
            </div>
            <div class="menu-item" @click.stop="goToSettings">
              <app-icon icon="hugeicons:setting-07" width="18" />
              <span>Settings</span>
            </div>
            <div class="menu-item" @click.stop="logout">
              <app-icon icon="hugeicons:logout-01" width="18" />
              <span>Logout</span>
            </div>
          </div>
        </div>
      </header>    
</template>

<script>
//import reportService from "@/services/reports.js";
import { useConfigStore } from "@/store/config";

export default {
  name: "NaviHeader",
  props: {
    
  },
  data() {
    return {
      menuOpen: false,
      configStore: useConfigStore()
    };
  },
  computed: {
    userFullName() {
      const firstName = this.configStore.userFirstName || '';
      const lastName = this.configStore.userLastName || '';
      return `${firstName} ${lastName}`.trim() || 'User';
    }
  },
  mounted() {
    // Close menu when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    // Clean up event listener
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {   
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    handleClickOutside(event) {
      const userProfile = this.$el.querySelector('.user-profile');
      if (userProfile && !userProfile.contains(event.target)) {
        this.menuOpen = false;
      }
    },
    goToSettings() {
      console.log('Navigate to Settings');
      // TODO: Add navigation to settings page
      // this.$router.push('/settings');
      this.menuOpen = false;
    },
    logout() {
      console.log('Logging out');

      this.configStore.logout();
      this.$router.push('/');
      this.menuOpen = false;
    }
  }
};
</script>

<style>
    .header {
        height: 80px;
        background: white;
        border-bottom: 1px solid var(--border);
        padding: 10px 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 82px
    }
      
    .header h1 {
        font-size: 20px;
        margin: 0;
    }

    .header p {
        font-size: 13.6px;
        color: var(--text-muted);
        margin: 0;
    }

    .user-profile {
        position: relative;
        cursor: pointer;
    }

    .avatar {
        width: 40px;
        height: 40px;
        background: var(--orange);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 12.8px;
        color: white; 
        transition: transform 0.2s ease;
    }

    .user-profile:hover .avatar {
        transform: scale(1.05);
    }

    .context-menu {
        position: absolute;
        top: calc(100% + 8px);
        right: 0;
        background: white;
        border: 1px solid var(--border);
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        min-width: 200px;
        overflow: hidden;
        z-index: 1000;
        animation: menuSlideIn 0.15s ease-out;
    }

    .menu-header {
        padding: 16px 16px 12px 16px;
        border-bottom: 1px solid var(--border);
        font-size: 14px;
        color: var(--text);
    }

    .menu-header strong {
        display: block;
        color: var(--orange);
        font-weight: 600;
    }

    @keyframes menuSlideIn {
        from {
            opacity: 0;
            transform: translateY(-8px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .menu-item {
        padding: 12px 16px;
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        transition: background-color 0.15s ease;
        font-size: 14px;
    }

    .menu-item:hover {
        background-color: #f5f5f5;
    }

    .menu-item:active {
        background-color: #ebebeb;
    }

    .menu-icon {
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
    }

    .menu-item + .menu-item {
        border-top: 1px solid var(--border);
    }
      

</style>